export default __webpack_public_path__ + "static/media/photo--lg--hockey.63a7ef43.jpg";